import { Box } from "@mui/material";
import React from "react";
import { IoIosHeart, IoIosHeartEmpty } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import "../Assets/css/influencer.css";
import Access from "../Assets/Img/Access.png";
import facebook from "../Assets/Img/facebook.png";
import Heart from "../Assets/Img/Heart.svg";
import profile from "../Assets/Img/Imgs.png";
import instagram from "../Assets/Img/instagram.png";
import youtube from "../Assets/Img/youtube.png";
import { formatNumberWithSuffix } from "../../utils/functions";

function InfluencerGridList({
  influencers = [],
  toggleFavorite,
  isFavoritesFiltered,
}) {
  const navigate = useNavigate();

  return (
    <>
      {/* Case 1: No favorite influencers */}
      {influencers.length === 0 && isFavoritesFiltered === true ? (
        <div
          className="min-h-screen flex items-center justify-center bg-gray-50"
          style={{ marginTop: "95px" }}
        >
          <div className="text-center px-4 max-w-md mx-auto">
            <img src={Heart} alt="No Favorites" className="object-contain" />
            <h2 className="Title">No favorite influencers selected!</h2>
          </div>
        </div>
      ) : influencers.length === 0 ? (
        // Case 2: No influencers found (e.g., search result is empty)
        <div
          className="min-h-screen flex items-center justify-center bg-gray-50"
          style={{ marginTop: "95px" }}
        >
          <div className="text-center px-4 max-w-md mx-auto">
            <img src={Access} alt="No Users Found" className="object-contain" />
            <h2 className="Title">No influencers found!</h2>
          </div>
        </div>
      ) : (
        // Case 3: Influencers available – show grid
        <div className="row g-3 TableBox mt-1">
          {influencers.map((influencer) => (
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-12"
              key={influencer.user_id}
              onClick={() => navigate(`/influencer/${influencer.user_id}`)}
              style={{ cursor: "pointer" }}
            >
              <div className="InfluencerGridList">
                <div className="influencer-card">
                  <div className="ImgBox">
                    <div className="favorite-icon position-absolute top-0 start-0 m-2">
                      <div className="Likes">
                        <Box
                          width={"35px"}
                          height={"35px"}
                          sx={{
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleFavorite(influencer.user_id);
                          }}
                        >
                          {influencer.flag_favorite ? (
                            <IoIosHeart color="#6b8e76" size={35} />
                          ) : (
                            <IoIosHeartEmpty color="#6b8e76" size={35} />
                          )}
                        </Box>
                      </div>
                    </div>

                    <div className="InfluencerProfile">
                      <img
                        src={influencer?.profile ? influencer.profile : profile}
                        className="img-fluid"
                        style={{
                          borderTopLeftRadius: "17px",
                          borderTopRightRadius: "17px",
                          minHeight: "150px",
                        }}
                        alt={
                          [influencer?.first_name, influencer?.last_name]
                            .filter(Boolean)
                            .join(" ") || "Influencer"
                        }
                      />
                      <h4
                        style={{
                          padding: "10px 10px",
                          textTransform: "capitalize",
                        }}
                      >
                        {[influencer?.first_name, influencer?.last_name]
                          .filter(Boolean)
                          .join(" ") || "Unknown Influencer"}
                      </h4>
                    </div>
                  </div>

                  <div className="details">
                    {influencer?.genre ? (
                      <div className="Name">
                        <span>{influencer.genre}</span>
                      </div>
                    ) : (
                      <></>
                    )}
                    <div
                      className="SocialPresence"
                      style={{ padding: "0 20px" }}
                    >
                      <div className="Dats">
                        <div>
                          <span>Reach</span>
                          {influencer?.reach === null ||
                          influencer?.reach === undefined
                            ? "N/A"
                            : formatNumberWithSuffix(influencer.reach)}
                        </div>
                        <div>
                          <span>Engagement</span>
                          {influencer?.engagement === null ||
                          influencer?.engagement === undefined
                            ? "N/A"
                            : formatNumberWithSuffix(influencer?.engagement)}
                        </div>
                        <div>
                          <span>Genuine</span>
                          <div className="d-flex ms-4">
                            {influencer?.instagram_stats?.genuine_followers ===
                              0 ||
                            influencer?.instagram_stats?.genuine_followers ==
                              null ? (
                              "N/A"
                            ) : (
                              <>
                                {Number(
                                  influencer.instagram_stats.genuine_followers.toFixed(
                                    0
                                  )
                                )}
                                <span className="Persant">%</span>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div style={{ padding: "0 20px" }}>
                      <h5>Followers</h5>
                      <div className="Dats flex gap-1">
                        <div className="flex items-center gap-1">
                          <img
                            src={instagram}
                            alt="Instagram"
                            className="w-6 h-6"
                          />
                          <strong className="follower-text-lg">
                            {influencer?.followers === null ||
                            influencer?.followers === undefined
                              ? "N/A"
                              : formatNumberWithSuffix(influencer.followers)}
                          </strong>
                        </div>
                        <div className="flex items-center gap-1">
                          <img
                            src={youtube}
                            alt="YouTube"
                            className="w-6 h-6"
                          />
                          <strong className="follower-text-lg">
                            {influencer?.followers === null ||
                            influencer?.followers === undefined
                              ? "N/A"
                              : formatNumberWithSuffix(influencer.followers)}
                          </strong>
                        </div>
                        <div className="flex items-center gap-1">
                          <img
                            src={facebook}
                            alt="Facebook"
                            className="w-6 h-6"
                          />
                          <strong className="follower-text-lg">
                            {influencer?.followers === null ||
                            influencer?.followers === undefined
                              ? "N/A"
                              : formatNumberWithSuffix(influencer.followers)}
                          </strong>
                        </div>
                      </div>
                    </div>

                    <hr />
                    <div style={{ padding: "0 20px 20px" }}>
                      <h5>Audience%</h5>
                      <div className="Dats">
                        <div>
                          <span>Male</span>
                          <strong>
                            {influencer?.male === null ||
                            influencer?.male === undefined
                              ? "N/A"
                              : influencer?.male}
                          </strong>
                        </div>
                        <div>
                          <span>Female</span>
                          <strong>
                            {influencer?.female === null ||
                            influencer?.female === undefined
                              ? "N/A"
                              : influencer.female}
                          </strong>
                        </div>
                        <div>
                          <span>Others</span>
                          <strong>
                            {influencer?.other === null ||
                            influencer?.other === undefined
                              ? "N/A"
                              : influencer.other}
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}

export default InfluencerGridList;
